import React from 'react'
import * as R from 'ramda'

import { HeaderCell } from 'components/shared/Table/common/Cells/HeaderCell/HeaderCell'
import { Table } from 'components/shared/Table/Table'

import jobStyles from '../../JobsListing.module.scss'

export const JobsTableHeader = ({
  headers,
  isAllRowsSelected,
  isSomeRowsSelected,
  isFetching,
  onToggleAllRowsSelected,
}) => (
  <Table.Head>
    <Table.Row
      type="head"
      onChange={onToggleAllRowsSelected}
      isChecked={isAllRowsSelected}
      isIndeterminate={isSomeRowsSelected}
      hasCheckbox={R.not(isFetching)}
    >
      {R.map(({ columnDef, getToggleSortingHandler, getIsSorted }) => {
        const { accessorKey, header, alignLeft } = columnDef

        return (
          <HeaderCell
            key={header}
            sortType={getIsSorted()}
            text={header}
            onClick={getToggleSortingHandler()}
            hasSorting={accessorKey}
            className={alignLeft && jobStyles.alignLeft}
          />
        )
      }, headers)}
    </Table.Row>
  </Table.Head>
)

